<template>
  <div class="mini-dialog">
    <div class="d-dialog w-480px h-282px absolute top-145px left-[calc(50%-240px)]" v-drag>
      <div
        class="d-dialog__header flex justify-between items-center h-60px pt-20px pl-20px pr-20px pb-10px"
      >
        <span class="text-white text-14px">GIS原点设置</span>
        <span
          class="text-white iconfont icon-line-close cursor-pointer text-12px"
          @click="closeDialog"
        ></span>
      </div>
      <div class="d-dialog__body p-20px w-full h-148px overflow-y-auto">
        <el-form
          ref="modifyForm"
          :model="modifyForm"
          :rules="modifyFormRules"
          label-width="80px"
          size="small"
        >
          <el-form-item label="经度" prop="longitude">
            <el-input v-model="modifyForm.longitude"></el-input>
          </el-form-item>
          <el-form-item label="纬度" prop="latitude">
            <el-input v-model="modifyForm.latitude"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="d-dialog__footer w-full h-76px p-20px text-center">
        <el-button type="primary" size="small" @click="pickupAnchor">拾取锚点</el-button>
        <el-button type="primary" size="small" @click="saveGisOriginPoint">保 存</el-button>
        <el-button size="small" @click="closeDialog">取 消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { ModelSceneApi } from '@wiz-api/scene-management'

const modelSceneApi = new ModelSceneApi()
export default {
  name: 'SetOriginPoint',
  props: {
    player: {
      type: Object,
      defalut: null,
    },
    modifyOptions: {
      type: Object,
      default: () => {
        return {
          id: '',
          name: '',
          latitude: '',
          longitude: '',
          isEnableGis: false,
          folderId: '',
        }
      },
    },
  },
  data() {
    return {
      modifyForm: {
        longitude: '',
        latitude: '',
      },
      modifyFormRules: {
        longitude: [{ required: true, message: '请输入经度', trigger: 'blur' }],
        latitude: [{ required: true, message: '请输入纬度', trigger: 'blur' }],
      },
    }
  },
  created() {
    this.modifyForm.longitude = this.modifyOptions.longitude
    this.modifyForm.latitude = this.modifyOptions.latitude
  },
  methods: {
    // 拾取锚点
    async pickupAnchor() {
      this.$refs.modifyForm.clearValidate()
      const pos = await this.player.Native.Camera.getAnchorPos()
      const llh = await this.player.Native.GisPlatform.worldToLLH(pos)
      if (llh) {
        this.modifyForm.longitude = llh[0] || 0
        this.modifyForm.latitude = llh[1] || 0
      }
    },
    // 关闭弹框
    closeDialog() {
      this.$emit('close')
    },
    // 保存数据
    saveGisOriginPoint() {
      this.$refs.modifyForm.validate(async (valid) => {
        if (valid) {
          const [err, res] = await modelSceneApi.update({
            id: this.modifyOptions.id,
            longitude: this.modifyForm.longitude,
            latitude: this.modifyForm.latitude,
            name: this.modifyOptions.name,
            folderId: this.modifyOptions.folderId,
            isEnableGis: this.modifyOptions.isEnableGis,
          })
          if (!err) {
            this.$message.success('设置成功')
            this.$emit('setSucess', this.modifyForm)
            this.closeDialog()
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/index';

.d-dialog {
  margin-top: 0 !important;
  background-color: rgba(24, 41, 72, 0.8);
}
</style>
